import React from 'react';
import { TextField } from '@material-ui/core';
import { SearchRounded } from '@material-ui/icons';
import Text from '../../../shared/common/Text';
import { CenterSearchMember, ContainerGroupsForm } from '../styled-components/groups.styled.components';

const SearchMember = props => {
    const { search, handleSearch } = props;

    // RETURN
    return (
        <ContainerGroupsForm>
            <Text fontSize="1rem" fontWeight="700" color="primary">
                Integrantes
            </Text>
                <CenterSearchMember>
                    <TextField
                        value={search}
                        onChange={handleSearch}
                        type="text"
                        placeholder="Buscar integrantes"
                        InputProps={{
                            endAdornment: <SearchRounded color="secondary" />,
                        }}
                        variant="outlined"
                        style={{ width: '100%' }}
                    />
                </CenterSearchMember>
        </ContainerGroupsForm>
    );
};

export default SearchMember;
